function Badge({ items, className = 'flex gap-1' }) {
  if (!items?.length) {
    return <></>
  }

  return (
    <div className={className}>
      {items.map((item) => (
        <span className={`badge whitespace-nowrap text-center ${item.customClass}`}>{item.text}</span>
      ))}
    </div>
  )
}

export default Badge
